import { createFileRoute } from '@tanstack/react-router';
import { DonationPage } from '@/components/donations';

// Public, UNAUTHENTICATED donor donation page. NO `beforeLoad` — that is what
// makes this route public (no auth redirect). The subsidiary rides in the URL
// (never an X-Subsidiary header), so the page + its API calls read it from the
// route params, not the build-time subsidiary or any auth context.
export const Route = createFileRoute('/$subsidiary/donate/$slug')({
  component: DonationRoute,
});

function DonationRoute() {
  const { subsidiary, slug } = Route.useParams();
  return <DonationPage subsidiary={subsidiary} slug={slug} />;
}
